<template>
  <v-text-field
    v-if="normalizedFieldType === 'url'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    clearable
    prepend-inner-icon="mdi-link-variant"
    :label="label"
    :placeholder="placeholder"
    @keyup.enter="$emit('enter')"
  />
  <v-text-field
    v-else-if="normalizedFieldType === 'short_text'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    clearable
    prepend-inner-icon="mdi-form-textbox"
    :label="label"
    :placeholder="placeholder"
    @keyup.enter="$emit('enter')"
  />
  <v-textarea
    v-else-if="normalizedFieldType === 'long_text'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    :rows="rows"
    auto-grow
    :label="label"
    :placeholder="placeholder"
  />
  <v-text-field
    v-else-if="normalizedFieldType === 'number'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    type="number"
    step="0.01"
    prepend-inner-icon="mdi-numeric"
    :label="label"
    :placeholder="placeholder"
    @keyup.enter="$emit('enter')"
  />
  <v-text-field
    v-else-if="normalizedFieldType === 'phone'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    clearable
    prepend-inner-icon="mdi-phone-outline"
    :label="label"
    :placeholder="placeholder"
    @keyup.enter="$emit('enter')"
  />
  <v-text-field
    v-else-if="normalizedFieldType === 'email'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    clearable
    prepend-inner-icon="mdi-email-outline"
    :label="label"
    :placeholder="placeholder"
    @keyup.enter="$emit('enter')"
  />
  <v-text-field
    v-else-if="normalizedFieldType === 'date'"
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    type="date"
    prepend-inner-icon="mdi-calendar"
    :label="label"
    :placeholder="placeholder"
  />
  <v-switch
    v-else-if="normalizedFieldType === 'checkbox'"
    v-model="localBooleanValue"
    color="primary"
    hide-details
    inset
    :label="checkboxLabel"
  />
  <v-select
    v-else-if="normalizedFieldType === 'select'"
    v-model="localValue"
    :items="selectOptions"
    item-title="label"
    item-value="value"
    :variant="variant"
    :density="density"
    hide-details
    :menu-props="menuProps"
    :label="label"
    :placeholder="placeholder"
  />
  <v-text-field
    v-else
    v-model="localValue"
    :variant="variant"
    :density="density"
    hide-details
    clearable
    :label="label"
    :placeholder="placeholder"
    @keyup.enter="$emit('enter')"
  />
</template>

<script>
export default {
  name: "NcrmContractItemFieldValueInput",
  props: {
    modelValue: {
      type: [String, Number, Boolean, null],
      default: null,
    },
    fieldType: {
      type: String,
      default: "short_text",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    checkboxLabel: {
      type: String,
      default: "",
    },
    selectOptions: {
      type: Array,
      default: () => [],
    },
    menuProps: {
      type: Object,
      default: () => ({}),
    },
    rows: {
      type: [String, Number],
      default: 2,
    },
    density: {
      type: String,
      default: "comfortable",
    },
    variant: {
      type: String,
      default: "outlined",
    },
  },
  emits: ["update:modelValue", "enter"],
  computed: {
    normalizedFieldType() {
      return String(this.fieldType || "").trim().toLowerCase();
    },
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    localBooleanValue: {
      get() {
        return this.modelValue === true;
      },
      set(value) {
        this.$emit("update:modelValue", value === true);
      },
    },
  },
};
</script>
